import { CarouselItem } from '@appsimples/atlantica-react-native/build/src/atoms/ATLAtomCarousel'
import React from 'react'
import { ImageSourcePropType } from 'react-native'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { setGlobal } from '../../global/useGlobal'
import { Expander } from './Expander'
import { CarouselImg, CarouselWrapper, CustomWebCarousel } from '../customCarousel/CustomCarousel.web'
import styled from 'styled-components'

const ImageWrapper = styled.div`
  position: relative;
`

interface CarouselProps {
  images: CarouselItem[]
}

export const Carousel: React.FunctionComponent<CarouselProps> = ({ images }) => {
  const onExpand = async (imageUrl: ImageSourcePropType) => {
    Coordinator.goToConstructionsImageDetail(imageUrl)
    await setGlobal({
      currentConstructionImageUrl: imageUrl,
    })
  }

  return (
    <CarouselWrapper>
      <CustomWebCarousel
        showArrows={true}
        showThumbs={false}
        showIndicators={false}
        showStatus={false}
        centerMode={true}
        centerSlidePercentage={80}
      >
        {images.map(item => {
          return (
            <ImageWrapper onClick={() => onExpand(item.image)} key={item.id}>
              <CarouselImg src={item.image} />
              <Expander onPressExpand={() => onExpand(item.image)} isWeb />
            </ImageWrapper>
          )
        })}
      </CustomWebCarousel>
    </CarouselWrapper>
  )
}
